// extracted by mini-css-extract-plugin
module.exports = {"item":"G_cv","item__image":"G_cw"};